import state from "../state/state";

export const AI_ASSISTANT_LAUNCH_EVENT = "ambifi:ai-assistant-launch";

let requestSeq = 0;

function buildRequestId() {
	requestSeq += 1;
	return `${Date.now()}-${requestSeq}`;
}

function isDevHost() {
	if (typeof window === "undefined" || !window.location || !window.location.hostname) {
		return false;
	}
	const host = window.location.hostname;
	return host === "localhost" || host === "local.ambifi.com" || host === "dev-app.ambifi.com";
}

function isAiAssistantLaunchEnabled() {
	const urlParams = state.get(["appState", "urlParams"]) || {};
	const flag = urlParams && Object.prototype.hasOwnProperty.call(urlParams, "aiAssistant")
		? urlParams.aiAssistant
		: undefined;
	return flag === true || flag === "true" || isDevHost();
}

export function launchAiAssistant(request = {}) {
	if (!isAiAssistantLaunchEnabled()) {
		return null;
	}

	const launchRequest = {
		requestId: buildRequestId(),
		mode: request.mode || "org",
		prefillQuestion: typeof request.prefillQuestion === "string" ? request.prefillQuestion : "",
		preferredPanelMode: request.preferredPanelMode === "overlay" || request.preferredPanelMode === "side"
			? request.preferredPanelMode
			: "",
		targetPath: Array.isArray(request.targetPath) ? request.targetPath : null,
		targetLabel: typeof request.targetLabel === "string" ? request.targetLabel : "",
		targetFieldType: typeof request.targetFieldType === "string" ? request.targetFieldType : "",
		responseFormat: typeof request.responseFormat === "string" ? request.responseFormat : "",
		targetReadOnly: request.targetReadOnly === true,
		featureName: typeof request.featureName === "string" ? request.featureName : "",
		featureDescription: typeof request.featureDescription === "string" ? request.featureDescription : "",
		additionalContextLines: Array.isArray(request.additionalContextLines) ? request.additionalContextLines : [],
		autoRun: request.autoRun === true
	};

	state.set(["appState", "aiAssistantLaunchRequest"], launchRequest);

	if (typeof window !== "undefined" && typeof window.dispatchEvent === "function" && typeof window.CustomEvent === "function") {
		window.dispatchEvent(new window.CustomEvent(AI_ASSISTANT_LAUNCH_EVENT, {
			detail: launchRequest
		}));
	}

	return launchRequest;
}
